var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93776 0.92456C7.94556 0.924415 7.95337 0.924415 7.96118 0.92456H8.57451V1.54956L8.57451 8.45106C8.57451 8.79624 8.29469 9.07606 7.94951 9.07606C7.60433 9.07606 7.32451 8.79624 7.32451 8.45106L7.32451 3.05877L1.49224 8.89308C1.2482 9.1372 0.852543 9.1372 0.608508 8.89308C0.364473 8.64896 0.364473 8.25316 0.608508 8.00904L6.44096 2.17456L1.05042 2.17456C0.705237 2.17456 0.425415 1.89474 0.425415 1.54956C0.425415 1.20438 0.705237 0.92456 1.05042 0.92456L7.93776 0.92456Z",
    fill: "#01021D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.f267e9857eae9e97987f2813c51975c6.svg";
export { ForwardRef as ReactComponent };